export const RFQ_TYPES = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'URGENT', label: 'Urgent' },
  { value: 'RATE_CONTRACT', label: 'Rate Contract' },
  { value: 'EMERGENCY', label: 'Emergency' },
];

export const RFQ_STATUSES = [
  'DRAFT',
  'PUBLISHED',
  'CLOSED',
  'EVALUATED',
  'AWARDED',
  'CANCELLED',
];

/** Workflow stepper labels (main happy path) */
export const RFQ_WORKFLOW_STAGES = [
  { key: 'DRAFT', label: 'Draft' },
  { key: 'PUBLISHED', label: 'Published' },
  { key: 'CLOSED', label: 'Closed' },
  { key: 'AWARDED', label: 'Awarded' },
];

export const MAX_RFQ_ATTACHMENT_BYTES = 5 * 1024 * 1024;
export const ALLOWED_RFQ_ATTACHMENT_MIME = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const QUOTE_EVALUATION_STATUSES = [
  { value: 'RECOMMENDED', label: 'Recommended' },
  { value: 'QUALIFIED', label: 'Qualified' },
  { value: 'REJECTED', label: 'Rejected' },
];
